<script lang="ts" setup>
import { computed } from 'vue'
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import { useAppChatStore } from '@/stores/appChatStore'
import type { Props } from '@/components/pd/ShareAndEarnBanner/types'
import { getReferralBonus } from '@/utils/referralBonus'

const { t, locale } = useI18n()

const bonusWithCurrency = computed(() => getReferralBonus(locale.value, true))
const { $useLhId } = useNuxtApp()

withDefaults(defineProps<Props>(), {
  dataAttributes: {
    dataLh: { P: 'unknown', Z: 'unknown' }
  }
})

const appChatStore = useAppChatStore()

const handleShareAndEarnClick = () => {
  const endpointConfig = {
    screen: 'PDP',
    entryNameAlias: 'PDP_REFER_AND_EARN',
    startFlow: true,
    shouldCallBotForGreeting: true
  }

  appChatStore.openChatWindow(endpointConfig)
}

</script>

<script lang="ts">
export default {
  name: 'ShareAndEarnBanner'
}
</script>

<template>
  <section
    class="share-and-earn-banner flex">
    <p
      v-sanitize="t('title', { bonusWithCurrency })"
      class="text-pine-600 text-20 font-medium" />

    <RoomieButton
      id="pd-share-and-earn-button"
      :data-lh-id="$useLhId({ ...dataAttributes.dataLh, A: 'seleccionar', C: t('cta') })"
      type="button"
      variant="secondary"
      class="w-fit mt-16 lg:mt-0"
      @click="handleShareAndEarnClick">
      {{ t('cta') }}
    </RoomieButton>
  </section>
</template>

<style lang="scss">
.share-and-earn-banner {
  @apply flex-col bg-lime-600 rounded-24;
  @apply items-start mx-24 p-24 mt-48;

  @media (width >= theme('screens.lg')) {
    @apply flex-row items-center py-24 px-32 justify-between;

    margin-left: 13.1rem;
    margin-right: 13.1rem;
    margin-top: 5.5rem;
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
